/**
 * @generated SignedSource<<7012544dbd91a229a434fdd3788a25e1>>
 * @relayHash 91887a9e3573303ceca2f07967fb5178
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0d8810639e582d4804789963246644a36f4a4dbd630082e7d05e701a633bf346

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { VirtualAgentViewIntentQuery } from './VirtualAgentViewIntentQuery.graphql';

import checkForAiEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';

const node: PreloadableConcreteRequest<VirtualAgentViewIntentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0d8810639e582d4804789963246644a36f4a4dbd630082e7d05e701a633bf346",
    "metadata": {},
    "name": "VirtualAgentViewIntentQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
    }
  }
};

export default node;
